export const searchActionTypes= {
    SET_SEARCH_INPUT: 'SET_SEARCH_INPUT',
    SEARCH_LOADING_START: 'SEARCH_LOADING_START',
    SEARCH_LOADING_FINISH: 'SEARCH_LOADING_FINISH',
    SEARCH_LOADING_FAILURE: 'SEARCH_LOADING_FAILURE',
    GET_SEARCH_LOADING: 'GET_SEARCH_LOADING',
    SET_SEARCH_RESULT: 'SET_SEARCH_RESULT',
    SET_SEARCH_RESULT_SORTED: 'SET_SEARCH_RESULT_SORTED'
}